<template>
  <el-dialog
    title="会员收费明细"
    :visible="visible"
    width="1180px"
    custom-class="membership-pricing-dialog"
    append-to-body
    :show-close="false"
    :close-on-click-modal="true"
    @close="$emit('update:visible', false)"
  >
    <div class="membership-pricing">
      <header class="membership-pricing__hero">
        <img src="/assets/membership-pricing-header.webp" alt="" aria-hidden="true" />
        <div class="membership-pricing__hero-shade"></div>
        <div class="membership-pricing__intro">
          <span class="membership-pricing__eyebrow">YUNTU MEMBERSHIP</span>
          <h2>选择适合你的年度方案</h2>
          <p>从轻量体验到团队增长，四档权益清晰可见。</p>
        </div>
        <button
          type="button"
          class="membership-pricing__close"
          aria-label="关闭会员收费明细"
          title="关闭"
          @click="$emit('update:visible', false)"
        >
          <i class="el-icon-close" aria-hidden="true"></i>
        </button>
      </header>

      <section class="membership-pricing__body" aria-labelledby="membership-pricing-heading">
        <div class="membership-pricing__heading-row">
          <div>
            <span id="membership-pricing-heading">年度会员收费明细</span>
            <small>所有价格均为年度费用，具体服务以购买确认内容为准</small>
          </div>
          <span class="membership-pricing__service-note">
            <i class="el-icon-service" aria-hidden="true"></i>
            高阶方案提供专属购买顾问
          </span>
        </div>

        <div class="membership-plan-list">
          <article
            v-for="plan in plans"
            :key="plan.id"
            class="membership-tier-card"
            :class="`membership-tier-card--${plan.id.toLowerCase()}`"
          >
            <div class="membership-tier-card__accent"></div>
            <div class="membership-tier-card__topline">
              <span class="membership-tier-card__icon" aria-hidden="true"><i :class="plan.icon"></i></span>
              <span class="membership-tier-card__order">0{{ plan.order }}</span>
            </div>
            <div class="membership-tier-card__title">
              <div>
                <h3>{{ plan.name }}</h3>
                <span v-if="plan.badge" class="membership-tier-card__badge">{{ plan.badge }}</span>
              </div>
              <p>{{ plan.tagline }}</p>
            </div>
            <div class="membership-tier-card__price">
              <span>¥</span><strong>{{ plan.price }}</strong><small>/ 年</small>
            </div>
            <div class="membership-tier-card__audience">
              <span>适合</span>
              <p>{{ plan.audience }}</p>
            </div>
            <div class="membership-tier-card__benefits">
              <strong>核心权益</strong>
              <ul>
                <li v-for="benefit in plan.benefits" :key="benefit">
                  <i class="el-icon-check" aria-hidden="true"></i>
                  <span>{{ benefit }}</span>
                </li>
              </ul>
            </div>
            <button
              type="button"
              class="membership-tier-card__action"
              @click="$emit('choose', plan.id)"
            >
              <span>{{ plan.action }}</span>
              <i class="el-icon-right" aria-hidden="true"></i>
            </button>
          </article>
        </div>

        <footer class="membership-pricing__footer">
          <div>
            <i class="el-icon-info" aria-hidden="true"></i>
            <span>选择方案后由专属顾问确认服务范围、账号数量与开通方式。</span>
          </div>
          <button type="button" @click="$emit('consult', 'GENERAL')">不确定怎么选？咨询客服</button>
        </footer>
      </section>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MembershipPricingDialog',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      plans: [
        {
          id: 'PERSONAL',
          order: 1,
          name: '个人版',
          price: '365',
          icon: 'el-icon-user',
          tagline: '低门槛体验 AI，让日常创作更简单',
          audience: '个人用户 / 小商家 / 入门体验',
          action: '咨询购买个人版',
          benefits: ['基础对话功能', '简单内容生成', '轻量化体验，适合日常创作与试用入门']
        },
        {
          id: 'PROFESSIONAL',
          order: 2,
          name: '专业版',
          price: '1980',
          icon: 'el-icon-video-play',
          badge: '创作者首选',
          tagline: '从内容创作到短视频生产，一套解决',
          audience: '小型商家 / 短视频运营者',
          action: '咨询购买专业版',
          benefits: ['短视频与营销内容生成', '视频抽帧、组合等实用功能', '剧情提示词与智能提词器', '声音素材库', '约 10 个真人素材库容量']
        },
        {
          id: 'MASTER',
          order: 3,
          name: '大师版',
          price: '5980',
          icon: 'el-icon-magic-stick',
          tagline: '内容、素材、剧本、真人能力全面升级',
          audience: '高频创作 / 获客型商家 / 内容团队',
          action: '咨询购买大师版',
          benefits: ['包含专业版全部功能', '真人复刻', '真人素材库', 'AI 剧本智能合成', '真人素材库容量提升至 500 个', '更完整的营销素材制作能力']
        },
        {
          id: 'ENTERPRISE',
          order: 4,
          name: '企业版',
          price: '29800',
          icon: 'el-icon-office-building',
          badge: '团队增长方案',
          tagline: '面向企业增长、协作管理与渠道裂变',
          audience: '企业 / 团队 / 品牌方 / 区域代理商',
          action: '咨询购买企业版',
          benefits: ['相当于 10 个大师版账号', '赠送 50000 积分', '企业专用私域池与企业认证', 'AI 客服与客户线索跟踪', '企业分账与智能分佣', '公众号合伙人授权', '企业客户和代理商管理']
        }
      ]
    }
  }
}
</script>

<style>
.membership-pricing-dialog {
  max-width: calc(100vw - 32px);
  max-height: 92vh;
  margin-top: 4vh !important;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #e3e7ed;
  border-radius: 16px;
  background: #f7f8fa;
  box-shadow: 0 28px 90px rgba(15, 23, 42, .24);
}
.membership-pricing-dialog .el-dialog__header {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  padding: 0;
}
.membership-pricing-dialog .el-dialog__body { padding: 0; color: #172033; }
.membership-pricing { background: #f7f8fa; }
.membership-pricing__hero {
  min-height: 154px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 28px 34px;
  box-sizing: border-box;
  background: #f4efe8;
}
.membership-pricing__hero > img { width: 100%; height: 100%; position: absolute; inset: 0; object-fit: cover; object-position: center; }
.membership-pricing__hero-shade { position: absolute; inset: 0; background: linear-gradient(90deg, rgba(250, 247, 242, .99) 0%, rgba(250, 247, 242, .94) 40%, rgba(250, 247, 242, .22) 74%, rgba(250, 247, 242, .06) 100%); }
.membership-pricing__intro { max-width: 560px; position: relative; z-index: 1; }
.membership-pricing__eyebrow { color: #8a6330; font-size: 11px; font-weight: 800; letter-spacing: .16em; }
.membership-pricing__intro h2 { margin: 8px 0 6px; color: #182236; font-size: 28px; line-height: 1.2; letter-spacing: -.03em; }
.membership-pricing__intro p { margin: 0; color: #667085; font-size: 13px; }
.membership-pricing__close { width: 44px; height: 44px; position: absolute; z-index: 2; top: 16px; right: 16px; display: grid; place-items: center; border: 1px solid rgba(85, 96, 114, .16); border-radius: 10px; padding: 0; background: rgba(255, 255, 255, .82); color: #556072; font-size: 18px; cursor: pointer; transition: background-color .2s ease, border-color .2s ease, color .2s ease; }
.membership-pricing__close:hover { border-color: #aeb7c5; background: #fff; color: #172033; }
.membership-pricing__close:focus-visible, .membership-tier-card__action:focus-visible, .membership-pricing__footer button:focus-visible { outline: 3px solid rgba(37, 99, 235, .28); outline-offset: 2px; }
.membership-pricing__body { padding: 24px; }
.membership-pricing__heading-row { display: flex; align-items: flex-end; justify-content: space-between; gap: 24px; margin-bottom: 16px; }
.membership-pricing__heading-row > div { display: flex; flex-direction: column; gap: 4px; }
.membership-pricing__heading-row > div > span { color: #202a3a; font-size: 16px; font-weight: 800; }
.membership-pricing__heading-row small { color: #7b8493; font-size: 12px; }
.membership-pricing__service-note { display: inline-flex; align-items: center; gap: 7px; border: 1px solid #e2d4ba; border-radius: 999px; padding: 7px 11px; background: #fffaf1; color: #76521e; font-size: 12px; white-space: nowrap; }
.membership-plan-list { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; align-items: stretch; }
.membership-tier-card { --tier: #2f63cf; --tier-soft: #edf4ff; min-width: 0; min-height: 526px; overflow: hidden; position: relative; display: flex; flex-direction: column; border: 1px solid #dfe4eb; border-radius: 12px; padding: 18px; background: #fff; box-shadow: 0 5px 16px rgba(20, 30, 48, .045); }
.membership-tier-card--professional { --tier: #7455c6; --tier-soft: #f3efff; }
.membership-tier-card--master { --tier: #b47719; --tier-soft: #fff6e5; }
.membership-tier-card--enterprise { --tier: #17233c; --tier-soft: #edf0f5; border-color: #cbd2dc; }
.membership-tier-card__accent { height: 4px; position: absolute; top: 0; right: 0; left: 0; background: var(--tier); }
.membership-tier-card__topline { display: flex; align-items: center; justify-content: space-between; }
.membership-tier-card__icon { width: 40px; height: 40px; display: grid; place-items: center; border-radius: 10px; background: var(--tier-soft); color: var(--tier); font-size: 19px; }
.membership-tier-card__order { color: #c1c7d0; font-size: 11px; font-weight: 800; letter-spacing: .12em; }
.membership-tier-card__title { margin-top: 16px; }
.membership-tier-card__title > div { min-height: 29px; display: flex; align-items: center; gap: 8px; }
.membership-tier-card__title h3 { margin: 0; color: #192335; font-size: 21px; line-height: 1.3; }
.membership-tier-card__title p { min-height: 38px; margin: 5px 0 0; color: #737d8d; font-size: 12px; line-height: 1.55; }
.membership-tier-card__badge { border-radius: 999px; padding: 4px 7px; background: var(--tier-soft); color: var(--tier); font-size: 10px; font-weight: 800; white-space: nowrap; }
.membership-tier-card__price { display: flex; align-items: baseline; gap: 2px; margin-top: 14px; color: var(--tier); font-variant-numeric: tabular-nums; }
.membership-tier-card__price > span { font-size: 16px; font-weight: 800; }
.membership-tier-card__price strong { font-size: 36px; line-height: 1; letter-spacing: -.04em; }
.membership-tier-card__price small { margin-left: 3px; color: #8992a1; font-size: 11px; }
.membership-tier-card__audience { min-height: 70px; margin-top: 16px; border-radius: 9px; padding: 11px 12px; background: #f7f8fa; }
.membership-tier-card__audience > span { color: var(--tier); font-size: 10px; font-weight: 800; letter-spacing: .08em; }
.membership-tier-card__audience p { margin: 4px 0 0; color: #465164; font-size: 12px; font-weight: 700; line-height: 1.5; }
.membership-tier-card__benefits { flex: 1; margin-top: 16px; }
.membership-tier-card__benefits > strong { color: #2d3748; font-size: 12px; }
.membership-tier-card__benefits ul { display: flex; flex-direction: column; gap: 9px; margin: 11px 0 18px; padding: 0; list-style: none; }
.membership-tier-card__benefits li { display: flex; align-items: flex-start; gap: 7px; color: #4f5b6d; font-size: 13px; line-height: 1.45; }
.membership-tier-card__benefits li i { width: 16px; height: 16px; display: grid; flex: 0 0 16px; place-items: center; margin-top: 1px; border-radius: 50%; background: var(--tier-soft); color: var(--tier); font-size: 9px; font-weight: 900; }
.membership-tier-card__action { width: 100%; min-height: 44px; display: flex; align-items: center; justify-content: center; gap: 7px; border: 1px solid var(--tier); border-radius: 8px; padding: 0 12px; background: #fff; color: var(--tier); font-size: 13px; font-weight: 800; cursor: pointer; touch-action: manipulation; transition: background-color .2s ease, color .2s ease, box-shadow .2s ease; }
.membership-tier-card__action:hover { background: var(--tier); color: #fff; box-shadow: 0 7px 18px rgba(24, 35, 60, .16); }
.membership-tier-card__action:active { box-shadow: 0 3px 9px rgba(24, 35, 60, .13); }
.membership-pricing__footer { min-height: 52px; display: flex; align-items: center; justify-content: space-between; gap: 18px; margin-top: 16px; border-top: 1px solid #e2e6ec; padding-top: 16px; }
.membership-pricing__footer > div { display: flex; align-items: flex-start; gap: 7px; color: #737d8d; font-size: 12px; line-height: 1.5; }
.membership-pricing__footer > div i { margin-top: 2px; color: #8a6330; }
.membership-pricing__footer button { min-height: 44px; flex: 0 0 auto; border: 0; border-radius: 8px; padding: 0 15px; background: #17233c; color: #fff; font-size: 12px; font-weight: 800; cursor: pointer; transition: background-color .2s ease; }
.membership-pricing__footer button:hover { background: #253654; }
@media (max-width: 1120px) {
  .membership-plan-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .membership-tier-card { min-height: 480px; }
}
@media (max-width: 680px) {
  .membership-pricing-dialog { max-width: calc(100vw - 20px); max-height: 94vh; margin-top: 3vh !important; border-radius: 12px; }
  .membership-pricing__hero { min-height: 144px; padding: 24px 18px; }
  .membership-pricing__hero > img { object-position: 68% center; }
  .membership-pricing__hero-shade { background: linear-gradient(90deg, rgba(250, 247, 242, .99) 0%, rgba(250, 247, 242, .93) 65%, rgba(250, 247, 242, .4) 100%); }
  .membership-pricing__intro { max-width: calc(100% - 48px); }
  .membership-pricing__intro h2 { font-size: 22px; }
  .membership-pricing__intro p { max-width: 260px; line-height: 1.5; }
  .membership-pricing__close { top: 10px; right: 10px; }
  .membership-pricing__body { padding: 16px; }
  .membership-pricing__heading-row { align-items: flex-start; flex-direction: column; gap: 10px; }
  .membership-pricing__service-note { white-space: normal; }
  .membership-plan-list { grid-template-columns: 1fr; }
  .membership-tier-card { min-height: 0; }
  .membership-tier-card__title p { min-height: 0; }
  .membership-tier-card__title p, .membership-tier-card__audience p, .membership-tier-card__benefits li { font-size: 14px; }
  .membership-tier-card__action { min-height: 48px; font-size: 14px; }
  .membership-pricing__footer > div, .membership-pricing__footer button { font-size: 13px; }
  .membership-pricing__footer { align-items: stretch; flex-direction: column; }
  .membership-pricing__footer button { width: 100%; }
}
@media (prefers-reduced-motion: reduce) {
  .membership-pricing__close, .membership-tier-card__action, .membership-pricing__footer button { transition: none; }
}
</style>
